import { css } from '@/styled-system/css';

export const backdrop = css({
  position: 'fixed',
  inset: 0,
  bg: 'hpGrayTranslucent',
  zIndex: 'zIndexOverLoader',
  opacity: 0,
  transitionProperty: 'opacity',
  transitionDuration: '0.3s',
  transitionTimingFunction: 'ease',
  md: {
    position: 'absolute',
  },

  '&[data-open="true"]': {
    opacity: 1,
  },
});

export const sheet = css({
  position: 'fixed',
  inset: 0,
  bg: 'hpxWhite',
  zIndex: 'zIndexMax',
  display: 'flex',
  flexDirection: 'column',
  transform: 'translateX(100%)',
  transitionProperty: 'transform',
  transitionDuration: '0.3s',
  transitionTimingFunction: 'ease-out',
  md: {
    position: 'absolute',
  },

  '&[data-open="true"]': {
    transform: 'translateX(0)',
  },
});

export const header = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  minHeight: '48px',
  px: '1x',
  py: '1x',
  borderBottomWidth: '1px',
  borderBottomStyle: 'solid',
  borderBottomColor: 'hpxGrey400',
  flexShrink: 0,
});

export const headerTitle = css({
  fontSize: 'lg',
  fontWeight: 'bold',
  color: 'hpxBlue600',
  textAlign: 'center',
  flex: 1,
});

export const headerSpacer = css({
  width: '36px',
  flexShrink: 0,
});

export const content = css({
  flex: 1,
  overflowY: 'auto',
  padding: '2x',
});
